const doc = [({"da":({"js":({"admin":({"ability_groups":({"table":({"the_ability_group_was_deleted":"Adgangsgruppen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;